import { Routes } from '@angular/router';
import { AppShellComponent } from './layout/app-shell/app-shell.component';
import { HomeComponent } from './features/home/home.component';
import { ReportViewerComponent } from './features/reports/report-viewer.component';
import { ValidateFilingComponent } from './features/validate/validate-filing.component';
import { CompareFilingsComponent } from './features/compare/compare-filings.component';
import { PeriodComparisonComponent } from './features/trend/period-comparison.component';
import { BuildInstanceComponent } from './features/build/build-instance.component';
import { DevSpikeComponent } from './features/dev-spike/dev-spike.component';

export const routes: Routes = [
  {
    path: '',
    component: AppShellComponent,
    children: [
      { path: '', component: HomeComponent, title: 'Supervisory Data' },
      { path: 'reports', component: ReportViewerComponent, title: 'Report viewer' },
      { path: 'validate', component: ValidateFilingComponent, title: 'Validate filing' },
      { path: 'compare', component: CompareFilingsComponent, title: 'Compare filings' },
      { path: 'trend', component: PeriodComparisonComponent, title: 'Period comparison' },
      { path: 'build', component: BuildInstanceComponent, title: 'Build instance' },
      { path: 'dev', component: DevSpikeComponent, title: 'Developer' },
    ],
  },
  { path: '**', redirectTo: '' },
];
